// export default "http://192.168.2.27:8090"; //徐涛
// export default "http://192.168.2.43:8090"; //王天龙
// export default "http://139.155.206.164/manage/api"; //端口+线上
 export default "https://zhaixiaoqu.com/manage/api"; //域名+线上


// WEBPACK FOOTER //
// ./src/common/serverHost.js